'use client';

import type { FC } from 'react';
import { useLayoutEffect } from 'react';
import { useScreenLayout } from './useScreenLayout';

export const ScreenDisableSafeArea: FC = () => {
  const { setDisableSafeArea } = useScreenLayout();

  useLayoutEffect(() => {
    setDisableSafeArea(true);
    return () => setDisableSafeArea(false);
  }, [setDisableSafeArea]);

  return null;
};
